import { GET_USERS } from "../constant/index";

const initialState = {};

const getUsers = (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
      return {
        ...state,
        ...action.payload
      };
    default:
      return state;
  }
};

export default getUsers;
